import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "./redux/orderSlice";
import productReducer from "./redux/productSlice";
import userReducer from "./redux/userSlice";
import authReducer from "./redux/authSlice";
import cartReducer from "./redux/cartSlice";
import ratingReducer from "./redux/ratingSlice";
import reviewsReducer from "./redux/reviewSlice";
import couponReducer from "./redux/couponSlice";
import paymentReducer from './redux/paymentSlice';
import addressReducer from "./redux/addressSlice";

const store = configureStore({
  reducer: {
    products: productReducer,
    order: orderReducer,
    users: userReducer,
    auth: authReducer,
    cart: cartReducer,
    rating: ratingReducer,
    review: reviewsReducer,
    coupon: couponReducer,
    payment: paymentReducer,
    address: addressReducer
  },
});

export default store;
